import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { settingManageChange } from 'services/setting'

export default function useSetManageSetting(refetch: () => void) {
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: ISettingManagePayload) => {
            return settingManageChange(payload)
        },
        onSuccess: (data) => {
            toast.success('مشخصات صندوق با موفقیت تغییر یافت')
            refetch()
        },
        onError: () => {
            toast.error('مشکلی پیش آمده!')
        },
    })

    return { isLoading, mutate }
}
